import { v4 as uuid } from 'uuid';
import { mergeMap, of } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatModels from "@medsurf/flat-models";

@Injectable()
export class AnnotationSourceEntityFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">
  
  static getNewInstance(id: string,
                        annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType,
                        position: FlatModels.PointSharedModels.Point = { x: 0.5, y: 0.5},
                        zoom: number | null = null) {
    const annotationSource: FlatModels.AnnotationSourceEntityModels.AnnotationSource = {
      id,
      position,
      zoom,
      startType: FlatModels.AnnotationEntityModels.TipType.enum.none,
      annotation: annotation.id
    }
    return annotationSource;
  }
  
  static addAnnotationSource(store: Store,
                             id: string,
                             annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType,
                             position: FlatModels.PointSharedModels.Point = { x: 0.5, y: 0.5},
                             zoom: number | null = null) {
    // Get New Instance
    const annotationSource = AnnotationSourceEntityFacade.getNewInstance(id, annotation, position, zoom);
    
    // Add Annotation Source
    return store.dispatch(new FlatActions.AnnotationSourceEntityActions.AddEntity(annotationSource)).pipe(
      mergeMap((data) => of({data, annotationSource})),
    );
  }
  
  static getCopyInstance(store: Store,
                         id: string,
                         annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType) {
    // Get Data
    const typedAnnotationSources = store.selectSnapshot(FlatStates.AnnotationSourceEntityState.typedEntities$);
    
    // Get Annotation Source
    const annotationSource = structuredClone(typedAnnotationSources[id]);
    
    // Update Annotation Source
    annotationSource.id = uuid();
    annotationSource.annotation = annotation.id;
    
    return annotationSource;
  }

  //</editor-fold>
}
